import { getAsyncData, onPointsTrack } from '@support/utils';
import { getCategoryList } from '@support/api';

export async function getCategoryListFn($sensorTrack: any) {
  try {
    await nextTick();
    const { data } = await useAsyncData(() => getCategoryList());
    const options = getAsyncData(data).data;
    onPointsTrack($sensorTrack, {
      mon_line: 'support', // 业务线【必传】
      mon_scene: 'accessory_prices', // 业务具体场景 【必传】
      mon_type: 'api',
      ...getAsyncData(data).postData
    });
    return options
  } catch (error: any) {
    error?.msg && showToast(error.msg);
    onPointsTrack($sensorTrack, {
      mon_line: 'support', // 业务线【必传】
      mon_scene: 'accessory_prices', // 业务具体场景 【必传】
      mon_type: 'api',
      ...error.postData
    });
  }

}